import { createSelector } from 'reselect';

export const getDeposits = createSelector(
  (state) => state.deposits.data.deposits,
  (deposits) => {
    return deposits;
  }
);

export const getCurrentDeposit = createSelector(
  (state) => state.deposits.data.currentDeposit,
  (currentDeposit) => {
    return currentDeposit;
  }
);

export const getCurrentPage = createSelector(
  (state) => state.deposits.ui.currentPage,
  (currentPage) => {
    return currentPage;
  }
);

export const getPdf = createSelector(
  (state) => state.deposits.ui.pdf,
  (pdf) => {
    return pdf;
  }
);

export const getShowPdfViewer = createSelector(
  (state) => state.deposits.ui.showPdfViewer,
  (showPdfViewer) => {
    return showPdfViewer;
  }
);

export const getUsersByClientId = createSelector(
  (state) => state.deposits.data.usersByClientId,
  (usersByClientId) => {
    return usersByClientId;
  }
);

export const getShowEmailModal = createSelector(
  (state) => state.deposits.ui.showEmailModal,
  (showEmailModal) => {
    return showEmailModal;
  }
);



// WEBPACK FOOTER //
// ./src/selectors/admin/deposits/deposits.js